var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 51.3337C40.8866 51.3337 51.3333 40.887 51.3333 28.0003C51.3333 15.1137 40.8866 4.66699 28 4.66699C15.1134 4.66699 4.66667 15.1137 4.66667 28.0003C4.66667 40.887 15.1134 51.3337 28 51.3337Z",
    stroke: "#ADAFAF",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 37.3337C37.3333 37.3337 33.8333 32.667 28 32.667C22.1667 32.667 18.6667 37.3337 18.6667 37.3337",
    stroke: "#ADAFAF",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H21.0233",
    stroke: "#ADAFAF",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21H35.0233",
    stroke: "#ADAFAF",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown);
export default __webpack_public_path__ + "static/media/frown.87a7db046a1a7ad74df498f95534985f.svg";
export { ForwardRef as ReactComponent };